import React from 'react';
import PropTypes from 'prop-types';
import Link from '@cotyorg/ccx-atoms/Link';

const CardoElement = ({
  classNames, // TODO: review this
  linkUrl,
  linkOpenInNewWindow,
  accessibleLinkText,
  children,
  onClick,
  index,
  fullClickableArea,
  openLinkInNewTab,
}) => (
  fullClickableArea && onClick ? (
    <div
      onClick={() => onClick({ cardoIndex: index })}
      onKeyPress={() => onClick({ cardoIndex: index })}
      role="button"
      tabIndex="0"
      className={`${classNames} cardo__wrapper-click`}
    >
      {children}
    </div>
  ) : fullClickableArea && linkUrl ? (
    <Link
      testAttribute="cardo-element-link"
      extraClass={`${classNames} cardo__wrapper-link`}
      link={linkUrl}
      {...(openLinkInNewTab || linkOpenInNewWindow) && { target: '_blank' }}
    >
      {children}
      { accessibleLinkText && <span className="show-for-sr">{accessibleLinkText}</span> }
    </Link>
  ) : (
    <div className={classNames}>{children}</div>
  )
);

CardoElement.propTypes = {
  classNames: PropTypes.string,
  linkUrl: PropTypes.string,
  linkOpenInNewWindow: PropTypes.bool,
  children: PropTypes.node,
  accessibleLinkText: PropTypes.string,
  onClick: PropTypes.func,
  index: PropTypes.number,
  fullClickableArea: PropTypes.bool,
  openLinkInNewTab: PropTypes.bool,
};

export default CardoElement;
